import { EllipsisVertical, PenLine, Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { useMembershipActions } from '../model';

type Props = {
  id: string;
  canRemove: boolean;
  canUpdate: boolean;
};

const ActionDropdown = ({ id, canRemove, canUpdate }: Props) => {
  const { openRemoveDialog, openEditDialog } = useMembershipActions();

  if (!canRemove && !canUpdate) return null;

  const onRemove = () => openRemoveDialog(id);
  const onEdit = () => openEditDialog(id);

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Open menu">
          <EllipsisVertical />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {canUpdate && (
          <DropdownMenuItem onClick={onEdit}>
            <PenLine />
            Edit permission
          </DropdownMenuItem>
        )}
        {canRemove && (
          <DropdownMenuItem variant="destructive" onClick={onRemove}>
            <Trash2 />
            Remove member
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ActionDropdown;
